// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes animationRotate {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(1turn);
  }
}
/* Add Animation */
@keyframes animatetop {
  from {
    top: -300px;
    opacity: 0;
  }
  to {
    top: 0;
    opacity: 1;
  }
}
.__upload_music_container {
  background-color: black;
  padding-bottom: 100px;
}
.__upload_music_container .__upload_box {
  display: flex;
}
@media (max-width: 576px) {
  .__upload_music_container .__upload_box {
    flex-direction: column;
  }
}
.__upload_music_container .__upload_box .__upload_steps {
  min-width: 200px;
  max-width: 200px;
  padding: 50px 20px;
}
@media (max-width: 576px) {
  .__upload_music_container .__upload_box .__upload_steps {
    width: 100%;
  }
}
.__upload_music_container .__upload_box .__upload_music {
  width: 50%;
  background: #090909;
  padding: 20px 50px;
}
@media (max-width: 576px) {
  .__upload_music_container .__upload_box .__upload_music {
    width: 100%;
    padding: 0;
  }
}
.__upload_music_container .__upload_box .__upload_music form .__upload_form {
  margin-top: 1rem;
}
.__upload_music_container .__upload_box .__upload_music form .__upload_form .__form_control {
  width: 100%;
  margin-top: 20px;
}
.__upload_music_container .__upload_box .__upload_music form .__upload_form .__form_control .__label {
  font-size: 14px;
}
.__upload_music_container .__upload_box .__upload_music form .__upload_form .__form_control .__info {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.8);
}
.__upload_music_container .__upload_box .__upload_music form .__upload_form .__form_control .__upload_inputbox {
  margin-top: 7px !important;
  position: relative !important;
}
.__upload_music_container .__upload_box .__upload_music form .__upload_form .__form_control .__upload_inputbox .__input {
  border-radius: 25px !important;
  height: 50px !important;
  background-color: #171515 !important;
  display: flex;
  align-items: center;
  padding-left: 12px;
  color: rgba(255, 255, 255, 0.3137254902);
}
.__upload_music_container .__upload_box .__upload_music form .__upload_form .__form_control .__upload_inputbox .__input fieldset {
  border-color: #262626 !important;
}
.__upload_music_container .__upload_box .__upload_music form .__upload_form .__form_control .__upload_inputbox .__input .__selectedImg {
  height: 100% !important;
  width: 100% !important;
  object-fit: cover !important;
}
.__upload_music_container .__upload_box .__upload_music form .__upload_form .__form_control .__upload_inputbox .__image_box {
  cursor: pointer;
  height: 444px;
  background: #171515;
  border-radius: 25px;
}
.__upload_music_container .__upload_box .__upload_music form .__upload_form .__form_control .__upload_inputbox .__image_box .__tap_select {
  justify-content: center;
  display: flex;
  align-items: center;
  height: 100%;
  padding-top: 56px;
}
.__upload_music_container .__upload_box .__upload_music form .__upload_form .__form_control .__upload_inputbox .__image_box .__selectedImg {
  border-radius: 25px;
  height: 100% !important;
  width: 100% !important;
  object-fit: contain !important;
}
.__upload_music_container .__upload_box .__upload_music form .__upload_form .__form_control .__upload_inputbox .__input_filled {
  color: #ffffff;
}
.__upload_music_container .__upload_box .__upload_music form .__upload_form .__form_control .__upload_inputbox .__input_area {
  border-radius: 25px !important;
  background-color: #262626 !important;
}
.__upload_music_container .__upload_box .__upload_music form .__upload_form .__form_control .__upload_inputbox .__input_area fieldset {
  border-color: #262626 !important;
}
.__upload_music_container .__upload_box .__upload_music form .__upload_form .__form_control .__upload_inputbox .__input_icon {
  position: absolute;
  right: 24px;
  top: 11px;
}
.__upload_music_container .__upload_box .__upload_music form .__upload_form .__form_control .__upload_inputbox .__center_absolute {
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
}`, "",{"version":3,"sources":["webpack://./src/styles/_mixins.scss","webpack://./src/pages/UploadMusic/index.scss"],"names":[],"mappings":"AAGA;EACE;IACE,oBAAA;ECFF;EDIA;IACE,wBAAA;ECFF;AACF;ADKA,kBAAA;AAYA;EACE;IACE,WAAA;IACA,UAAA;ECJF;EDMA;IACE,MAAA;IACA,UAAA;ECJF;AACF;AA3BA;EACE,uBAAA;EACA,qBAAA;AA6BF;AA5BE;EACE,aAAA;AA8BJ;ADEE;ECjCA;IAGI,sBAAA;EAgCJ;AACF;AA/BI;EACE,gBAAA;EACA,gBAAA;EACA,kBAAA;AAiCN;ADRE;EC5BE;IAKI,WAAA;EAmCN;AACF;AAjCI;EACE,UAAA;EACA,mBAAA;EACA,kBAAA;AAmCN;ADlBE;ECpBE;IAMI,WAAA;IACA,UAAA;EAoCN;AACF;AAjCQ;EACE,gBAAA;AAmCV;AAlCU;EACE,WAAA;EACA,gBAAA;AAoCZ;AAnCY;EACE,eAAA;AAqCd;AAnCY;EACE,eAAA;EACA,+BAAA;AAqCd;AAnCY;EACE,0BAAA;EACA,6BAAA;AAqCd;AApCc;EACE,8BAAA;EACA,uBAAA;EACE,oCAAA;EACF,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,wCAAA;AAsChB;AArCgB;EACE,gCAAA;AAuClB;AArCgB;EACE,uBAAA;EACA,sBAAA;EACA,4BAAA;AAuClB;AApCc;EACE,eAAA;EAEA,aAAA;EACA,mBAAA;EACA,mBAAA;AAqChB;AApCgB;EACE,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;AAsClB;AApCgB;EACE,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,8BAAA;AAsClB;AAnCc;EACE,cAAA;AAqChB;AAnCc;EACE,8BAAA;EACA,oCAAA;AAqChB;AAnCgB;EACE,gCAAA;AAqClB;AAlCc;EACE,kBAAA;EACA,WAAA;EACA,SAAA;AAoChB;AAlCc;EACE,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;AAoChB","sourcesContent":["@import \"./colors.scss\";\n@import \"./breakpoints\";\n\n@keyframes animationRotate {\n  from {\n    transform: rotate(0);\n  }\n  to {\n    transform: rotate(1turn);\n  }\n}\n\n/* Add Animation */\n@-webkit-keyframes animatetop {\n  from {\n    top: -300px;\n    opacity: 0;\n  }\n  to {\n    top: 0;\n    opacity: 1;\n  }\n}\n\n@keyframes animatetop {\n  from {\n    top: -300px;\n    opacity: 0;\n  }\n  to {\n    top: 0;\n    opacity: 1;\n  }\n}\n\n// Small devices\n@mixin sm {\n  @media (max-width: #{$screen-sm-max}) {\n    @content;\n  }\n}\n\n@mixin upToSm {\n  @media (min-width: #{$screen-sm-min}) {\n    @content;\n  }\n}\n\n// Medium devices\n@mixin md {\n  @media (min-width: #{$screen-md-min}) {\n    @content;\n  }\n}\n\n// Large devices\n@mixin lg {\n  @media (min-width: #{$screen-lg-min}) {\n    @content;\n  }\n}\n\n// Extra large devices\n@mixin xl {\n  @media (min-width: #{$screen-xl-min}) {\n    @content;\n  }\n}\n\n// Custom devices\n@mixin rwd($screen) {\n  @media (min-width: #{$screen}px) {\n    @content;\n  }\n}\n\n@mixin screnRange($min, $max) {\n  @media (min-width: #{$min}px) and (max-width: #{$max}px) {\n    @content;\n  }\n}\n\n@mixin screenHeightRange($min, $max) {\n  @media (min-height: #{$min}px) and (max-height: #{$max}px) {\n    @content;\n  }\n}\n","@import \"./../../styles/mixins\";\n.__upload_music_container {\n  background-color: black;\n  padding-bottom: 100px;\n  .__upload_box {\n    display: flex;\n    @include sm {\n      flex-direction: column;\n    }\n    .__upload_steps {\n      min-width: 200px;\n      max-width: 200px;\n      padding: 50px 20px;\n      @include sm {\n        width: 100%;\n      }\n    }\n    .__upload_music {\n      width: 50%;\n      background: #090909;\n      padding: 20px 50px;\n\n      @include sm {\n        width: 100%;\n        padding: 0;\n      }\n\n      form {\n        .__upload_form {\n          margin-top: 1rem;\n          .__form_control {\n            width: 100%;\n            margin-top: 20px;\n            .__label {\n              font-size: 14px;\n            }\n            .__info {\n              font-size: 13px;\n              color: #ffffffcc;\n            }\n            .__upload_inputbox {\n              margin-top: 7px !important;\n              position: relative !important;\n              .__input {\n                border-radius: 25px !important;\n                height: 50px !important;\n                  background-color: #171515 !important;\n                display: flex;\n                align-items: center;\n                padding-left: 12px;\n                color: #ffffff50;\n                fieldset {\n                  border-color: #262626 !important;\n                }\n                .__selectedImg {\n                  height: 100% !important;\n                  width: 100% !important;\n                  object-fit: cover !important;\n                }\n              }\n              .__image_box {\n                cursor: pointer;\n\n                height: 444px;\n                background: #171515;\n                border-radius: 25px;\n                .__tap_select {\n                  justify-content: center;\n                  display: flex;\n                  align-items: center;\n                  height: 100%;\n                  padding-top: 56px;\n                }\n                .__selectedImg {\n                  border-radius: 25px;\n                  height: 100% !important;\n                  width: 100% !important;\n                  object-fit: contain !important;\n                }\n              }\n              .__input_filled {\n                color: #ffffff;\n              }\n              .__input_area {\n                border-radius: 25px !important;\n                background-color: #262626 !important;\n\n                fieldset {\n                  border-color: #262626 !important;\n                }\n              }\n              .__input_icon {\n                position: absolute;\n                right: 24px;\n                top: 11px;\n              }\n              .__center_absolute {\n                top: 0;\n                right: 0;\n                bottom: 0;\n                left: 0;\n                margin: auto;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
